import { createContext } from 'react'

type AuthContextType = {
  login: (MFA: string, Session: string, UserName: string) => Promise<void>
  logout: () => Promise<void>
  loginWithMicrosoft: () => Promise<void>
  acquireNewToken: () => Promise<string | null>
}

export const AuthContext = createContext<AuthContextType>({} as AuthContextType)
